import styled from 'styled-components';

const Footer = styled.footer`
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  width: 100vw;
  max-width: 100%;
  margin-top: 15vh;
  
  div {
    border-top: 2px solid #ebebeb;
    color: black;
    width: 1200px;
    max-width: 100%;
    padding: 12px 0;
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    * {
      margin-right: 24px;
    }
  
    @media (max-width: 1030px) {
      width: 90%;
      max-width: 90%;
    }
    img {
      width: 25px;
      height: auto;
    }
  }
  
`;

export {Footer};
